import Vue from 'vue';
import App from './app';
import router from './router';
import store from './store';
import 'reset.css'
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.less';
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
import axios from 'axios';
import VueAxios from "vue-axios";
import Validate from './utils/validate';
import { getToken, setToken, clearToken } from './utils/authToken';
import LyTab from 'ly-tab'
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);
Vue.use(LyTab)
Vue.use(VueAxios,axios);
Vue.use(Toast);
axios.interceptors.request.use(config => {
    const token = getToken();
    if (token) {
        config.headers.Token = token;
    }
    if (config.method === 'post') {
        if (!config.headers) config.headers = {};
        if (!config.data) config.data = {};
        let ret = '';
        for (let it in config.data) ret += encodeURIComponent(it) + '=' + encodeURIComponent(config.data[it]) + '&';
        ret = ret.substring(0, ret.lastIndexOf('&'));
        config.data = ret;
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return config;
});

axios.interceptors.response.use(
    res => {
      if(res.config.url.indexOf("/ssc_golang/v1/user/login") > -1 && (res.data.result=='ok' || (res.data.result=='error' && res.data.msg=='请您进行密码更换'))){
        setToken(res.data.data);
      }
      if(res.data.result=='error' && res.data.msg=='用户没有登录'){
        var fromurl = res.config.url
        if (fromurl.indexOf("user/userinfo") <= -1)
        {
          clearToken();
          window.location.reload()
        }
      }
      return res.data
    },
    err => {
      return Promise.reject(err.response.data)
    }
)

//axios.interceptors.response.use(info => info.data);

// 项目路径
axios.defaults.baseURL = '/api/';
axios.defaults.withCredentials = true;

Vue.prototype.$store = store;
Vue.prototype.$validate = Validate;
Vue.config.productionTip = false;
const whiteMap = ['/login'];


router.beforeEach((to, from, next) => {
    if (whiteMap.includes(to.path)) {
        return next();
    }
    // 用户存在
    if (!store.state.root.user.uid) {
        store.dispatch('root/getUserInfo').then(res => {
            if (!res.uid) {
                const query = 'path=' + to.path;
                return next('/login?' + encodeURI(query));
            }
            return next();
        });
    } else {
        next();
    }
});


window.vm_app = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js